.EmberEmbarkScreen {
  width: 100%;
  height: 100%;
  position: relative;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center top;
  background-image: url("@fae/source/assets/images/ember-tactics/screens/embark/embarkscreen3.lowres.png");
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.EmberEmbarkScreen .Blackout {
  top: 0em;
  left: 0em;
  right: 0em;
  bottom: 0em;
  z-index: 100;
  position: absolute;
  opacity: 1;
  animation-delay: 0.1s;
  animation-duration: 1s;
  animation-name: fadeout;
  animation-fill-mode: forwards;
  pointer-events: none;
  background-color: #000;
}
.EmberEmbarkScreen .Header .Text {
  font-size: 1em;
  text-stroke: 0.25em #000;
  -ms-text-stroke: 0.25em #000;
  -moz-text-stroke: 0.25em #000;
  -webkit-text-stroke: 0.25em #000;
  paint-order: stroke fill;
  display: none;
}
.EmberEmbarkScreen .Units {
  z-index: 10;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2em;
  margin: 0.5em 0em;
}
.EmberEmbarkScreen .Units .Unit {
  perspective: 10em;
}
.EmberEmbarkScreen .Units .Unit .Card {
  width: 2.75em;
  height: 4.75em;
  transform: rotateY(0deg);
  transform-style: preserve-3d;
  transition-property: transform, box-shadow;
  transition-duration: 0.25s;
  box-shadow: 0em 0.2em 0.4em #000;
}
.EmberEmbarkScreen .Units .Unit .Card .CardBack {
  width: 2.75em;
  height: 4.75em;
  position: absolute;
  transform: translateZ(-1px) rotateY(180deg);
  overflow: hidden;
  background-color: #000;
  background-repeat: no-repeat;
  background-image: url("@fae/source/assets/images/ember-tactics/screens/embark/cardback.lowres.png");
  background-size: cover;
  border-radius: 0.1em;
}
.EmberEmbarkScreen .Units .Unit .Card .CardFront {
  width: 2.75em;
  height: 4.75em;
  position: absolute;
  border-color: #000;
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  overflow: hidden;
  background-color: #000;
  background-size: 4em auto;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-image: url("@fae/source/assets/images/ember-tactics/screens/embark/cardbackground.png");
}
.EmberEmbarkScreen .Units .Unit .Card .CardFront .Number {
  top: 0em;
  right: 0em;
  color: #817F91;
}
.EmberEmbarkScreen .Units .Unit .Card .CardFront .Title {
  left: 0em;
  right: 0em;
  bottom: 0em;
  color: #FFF;
}
.EmberEmbarkScreen .Units .Unit .Card .CardFront .Title,
.EmberEmbarkScreen .Units .Unit .Card .CardFront .Number {
  z-index: 10000;
  position: absolute;
  padding: 0.1em 0.2em;
  text-align: center;
}
.EmberEmbarkScreen .Units .Unit .Card .CardFront .Title .Text,
.EmberEmbarkScreen .Units .Unit .Card .CardFront .Number .Text {
  text-stroke: 0.25em #000;
  -ms-text-stroke: 0.25em #000;
  -moz-text-stroke: 0.25em #000;
  -webkit-text-stroke: 0.25em #000;
  paint-order: stroke fill;
  line-height: 1em;
  font-size: 0.33em;
  font-family: var(--fancy-font);
}
.EmberEmbarkScreen .Units .Unit .Card .CardFront .Portrait {
  left: -4em;
  right: -4em;
  bottom: 0em;
  margin: auto;
  width: 4em;
  height: 100%;
  position: absolute;
}
.EmberEmbarkScreen .Units .Unit .Details {
  margin-top: 1em;
  text-align: center;
  font-size: 0.2em;
  opacity: 0;
  transition-duration: 1s;
  transition-delay: 1s;
  transition-property: opacity;
}
.EmberEmbarkScreen .Units .Unit .Details .Description {
  opacity: 0.5;
}
.EmberEmbarkScreen .Units .Unit .Details .LearnMoreButton {
  display: none;
  opacity: 0.5;
}
.EmberEmbarkScreen .Units .Unit .Details .LearnMoreButton:hover {
  opacity: 1;
  cursor: pointer;
}
.EmberEmbarkScreen .Units .Unit:not([isSelectable]) .Portrait {
  filter: brightness(0) drop-shadow(0.15em -0.1em #B7341A) drop-shadow(-0.1em -0.1em #B7341A);
}
.EmberEmbarkScreen .Units .Unit:not([isRevealed]) .Card {
  transform: rotateY(180deg);
}
.EmberEmbarkScreen .Units .Unit:not([isRevealed]) .Card:hover {
  cursor: pointer;
  box-shadow: 0em 0.4em 0.6em #000;
  transform: translateY(-0.2em) rotateY(180deg);
}
.EmberEmbarkScreen .Units .Unit[isRevealed] .Card {
  transform: rotateY(0deg);
}
.EmberEmbarkScreen .Units .Unit[isRevealed] .Details {
  opacity: 1;
}
.EmberEmbarkScreen .EmbarkButton {
  width: 2em;
  padding: 0.1em;
  border-radius: 0.1em;
  border-style: solid;
  border-width: 0.05em;
  border-color: #434C5A;
  color: #f0ead6;
  background-color: #14181C;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition-delay: 1.5s;
  transition-duration: 1s;
  transition-property: opacity;
  pointer-events: none;
}
.EmberEmbarkScreen .EmbarkButton .Text {
  font-size: 0.3em;
}
.EmberEmbarkScreen .EmbarkButton:hover {
  cursor: pointer;
  background-color: #1F242F;
}
.EmberEmbarkScreen .EmbarkButton[isVisible] {
  opacity: 1;
  pointer-events: all;
}
.WaitForClickScreen {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
}
.WaitForClickScreen .Button {
  font-size: 20px;
  line-height: 33px;
  cursor: pointer;
  padding: 0.4em 0.8em;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #B7341A;
  text-shadow: 0px 1px 0px #d04d33;
  box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.21);
  border-radius: 3px;
}
.WaitForClickScreen .Button svg {
  margin-right: 5px;
}
.WaitForClickScreen .Button:active {
  margin-top: 4px;
}
